<template>
  <transition enter-active-class="animate__animated animate__fadeIn"
    leave-active-class="animate__animated animate__fadeOut">
    <div class="root-box" v-if="show">
      <Loading size="24px" vertical color="#999"><span class="c_999999">加载中...</span></Loading>
    </div>
  </transition>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue'

import { Loading } from 'vant'
let show = ref(false)

const showLoading = () => {
  show.value = true
}
const hideLoading = (callback: any) => {
  show.value = false
  callback && setTimeout(() => callback(), 500)
}

defineExpose({
  show,
  showLoading,
  hideLoading
})

</script>

<style scoped lang="scss">
.animate__animated.animate__fadeIn {
  --animate-duration: 0.5s;
}

.animate__animated.animate__fadeOut {
  --animate-duration: 0.5s;
}

.root-box {
  margin: 0;
  z-index: 2000;
  height: 10vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
